<template>
<div class="body">
    <div class="subnav">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <a href="javascript:;" @click="toindex" style="color: #666666">首页</a>
            </el-breadcrumb-item>
            <el-breadcrumb-item>
                <a href="javascript:;" @click="back" style="color: #666666">我的发票</a>
            </el-breadcrumb-item>
            <el-breadcrumb-item>
                <a href="javascript:;" style="color: #3779ff">开具发票</a>
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="box">
        <div class="title">
            <p class="h1">发票信息</p>
        </div>
        <el-form ref="myform" :rules="rules" :model="myform" label-width="100px">
            <el-form-item label="抬头类型：" prop="type">
                <el-radio-group v-model="myform.type">
                    <el-radio label="企业单位" @change="getValue()"></el-radio>
                    <el-radio label="个人/非企业单位" @change="getValue()"></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="企业抬头：" prop="title" v-if="type == 2">
                <el-input v-model="myform.title" style="width: 380px" placeholder="请输入企业名称"></el-input>
            </el-form-item>

            <el-form-item label="企业税号：" prop="taxNumber" v-if="type == 2">
                <el-input v-model="myform.taxNumber" style="width: 380px" placeholder="请输入企业税号"></el-input>
            </el-form-item>
            <el-form-item label="抬头：" prop="title" v-if="type == 1">
                <el-input v-model="myform.title" style="width: 380px" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="身份证号：" prop="idCard" v-if="type == 1">
                <el-input v-model="myform.idCard" :maxlength="18" style="width: 380px" placeholder="请输入身份证号"></el-input>
            </el-form-item>
            <el-form-item label="企业地址：" prop="address" v-if="type == 2">
                <el-input v-model="myform.address" style="width: 380px" placeholder="请输入企业地址信息"></el-input>
            </el-form-item>
            <el-form-item label="开户银行：" prop="bank" v-if="type == 2">
                <el-input v-model="myform.bank" style="width: 380px" placeholder="请输入开户银行名称"></el-input>
            </el-form-item>
            <el-form-item label="银行账户：" prop="account" v-if="type == 2">
                <el-input v-model="myform.account" style="width: 380px" placeholder="请输入银行账号"></el-input>
            </el-form-item>
        </el-form>
    </div>
    <div class="box" style="margin-bottom: 0">
        <div class="title">
            <p class="h1">联系人信息</p>
        </div>
        <el-form ref="myform2" :rules="rules" :model="myform" label-width="100px" required>
            <el-form-item label="联系人：" prop="linkman" v-if="type == 2">
                <el-input v-model="myform.linkman" style="width: 380px" placeholder="请输入联系人姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
                <el-input v-model="myform.phone" style="width: 380px" placeholder="请输入联系人电话号码"></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱：" prop="email">
                <el-input v-model="myform.email" style="width: 380px" placeholder="请输入接收电子发票的邮箱"></el-input>
            </el-form-item>
        </el-form>
        <div class="bot_button">
            <button @click="submitForm">确认提交</button>
        </div>
    </div>
</div>
</template>

<script>
import {
    MessageBox
} from "element-ui";
export default {
    components: {},
    data() {
        return {
            type: 2,
            myform: {
                type: "企业单位",
                title: "",
                taxNumber: "",
                idCard: "",
                address: "",
                bank: "",
                account: "",
                linkman: "",
                phone: "",
                email: "",
                orderIdList: this.$route.params.orderidlist,
            },
            rules: {
                type: [{
                    required: true,
                    message: "请选择抬头类型",
                    trigger: "change"
                }, ],
                title: [{
                    required: true,
                    message: "请输入名称",
                    trigger: "blur"
                }],

                taxNumber: [{
                    required: true,
                    message: "请输入企业税号",
                    trigger: "blur"
                }, ],
                idCard: [{
                        required: true,
                        message: "请输入身份证号",
                        trigger: "blur"
                    }, {
                        min: 15,
                        max: 18,
                        message: '请输入正确的身份证号码',
                        trigger: 'blur'
                    },
                    {
                        required: true,
                        pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                        message: '请输入正确的身份证号码',
                        trigger: 'blur'
                    }
                ],
                address: [{
                    required: false,
                    message: "请输入企业地址信息",
                    trigger: "blur"
                }, ],
                bank: [{
                    required: false,
                    message: "请输入开户银行名称",
                    trigger: "blur"
                }, ],
                account: [{
                    required: false,
                    message: "请输入银行账户",
                    trigger: "blur"
                }, ],
                linkman: [{
                    required: true,
                    message: "请输入联系人姓名",
                    trigger: "blur"
                }, ],
                phone: [{
                    required: true,
                    message: "请输入联系人电话号码",
                    trigger: "blur"
                }],
                email: [{
                    required: true,
                    message: "请输入接收电子发票的邮箱",
                    trigger: "blur",
                }, ],
            },
        };
    },
    computed: {},
    watch: {},
    mounted() {
        // console.log(this.$route.params.orderidlist)
    },
    methods: {
        getValue() {
            if (this.myform.type == "个人/非企业单位") {
                this.type = 1;
                this.myform.idCard = "";
                this.myform.title = "";
            } else if (this.myform.type == "企业单位") {
                this.type = 2;
                this.myform.title = "";
                this.myform.taxNumber = "";
                this.myform.address = "";
                this.myform.bank = "";
                this.myform.account = "";
                this.myform.linkman = "";
            }
            this.$refs.myform.clearValidate();
            // console.log(this.type);
        },
        back() {
            this.$router.go(-1); //返回上一层
        },
        toindex() {
            this.$router.push({
                path: "/company"
            });
        },
        submitForm(formarray) {
            //   console.log(formarray);

            let arr = [];
            if (this.type == 2) {
                arr = [
                    this.myform.title,
                    this.myform.taxNumber,
                    this.myform.linkman,
                    this.myform.phone,
                    this.myform.email,
                ];
            } else {
                arr = [
                    this.myform.title,
                    this.myform.phone,
                    this.myform.email,
                    this.myform.idCard,
                ];
            }
            for (var i = 0; i <= arr.length; i++) {
                if (arr[i] == "") {
                    this.$message.error("您还有未填写的必填项");
                    return false;
                } else {}
            }
            let json = {
                account: this.myform.account,
                address: this.myform.address,
                bank: this.myform.bank,
                email: this.myform.email,
                idCard: this.myform.idCard,
                linkman: this.myform.linkman,
                orderIdList: this.$route.params.orderidlist.split(","),
                phone: this.myform.phone,
                taxNumber: this.myform.taxNumber,
                title: this.myform.title,
                type: this.type,
            };
            console.log(json);
            this.$http.post("/app/invoicerecord/save", json).then((res) => {
                // console.log(res);
                if (res.data.code == 0) {
                    this.$message.success(res.data.msg);
                    this.$router.push({
                        path: "/user/invoice",
                    });
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
    },
    created() {},

    beforeDestroy() {},
};
</script>

<style lang="less" scoped>
.body {
    background-color: #eee;
    padding-bottom: 20px;
}

.subnav {
    width: 1200px;
    margin: 0 auto;
    height: 60px;
    display: flex;
    align-items: center;
}

.box {
    width: 1200px;
    height: auto;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    margin: 0 auto;
    padding-top: 10px;
    margin-bottom: 20px;
    overflow: hidden;

    .title {
        width: 100%;
        border-bottom: 1px solid #eeeeee;
        height: 60px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .h1 {
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 1px;
            color: #333333;
            height: 20px;
            line-height: 20px;
            border-left: 3px solid #3779ff;
            padding-left: 15px;
        }
    }

    .el-form {
        margin-top: 20px;

        .el-input__inner {
            width: 380px !important;
        }
    }

    .bot_button {
        width: 100%;
        border-top: 1px solid #eeeeee;
        padding: 20px 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        button {
            margin-left: 10px;
            width: 160px;
            height: 44px;
            background-color: #3779ff;
            border-radius: 4px;
            font-size: 14px;
            font-weight: bold;
            color: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
        }
    }
}
</style>
